import useAppGuard from "./useAppGuard";
import React from "react";

export const AppGuard = ({ children }) => {
  const { grantAccess } = useAppGuard();

  return <>{grantAccess && children}</>;
};
